/* eslint-disable @typescript-eslint/naming-convention */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  CampaignUmbrellaAddEditStateType,
  SetModalPayloadActualType,
} from 'features/CampaignAndDiscount/@types/campaignUmbrellaAddEdit'

export const SLICE_NAME = 'campaignUmbrellaAddEdit'

const initialState: CampaignUmbrellaAddEditStateType = {
  isLoading: false,
  modal: {
    mode: '',
  },
  forms: {
    campaign_theme: '',
    submission_date_start: '',
    submission_date_end: '',
    campaign_exposures: [],
    attachment: '',
    is_public_campaign: false,
    promo_criteria: {
      bmsm: {
        quota_min: 0,
        amount_sku_min: 0,
        tiers: [],
      },
      flash_sale: {
        discount_min: 0,
        amount_sku_min: 0,
        quota_min: 0,
      },
      single_discount: {
        discount_min: 0,
        amount_sku_min: 0,
        quota_min: 0,
      },
    },
    project_id: '',
    campaign_targets: [],
    l0_objectives: [],
    l1_objectives: [],
    vendor_quota: 0,
    campaign_period_start: '',
    campaign_period_end: '',

    // Added missing properties to match GetCampaignUmbrellaDetailResponseType
    buyer_targets: [],
    can_edit: '',
    campaign_objectives: [],
    submission_status: '',

    campaign_cluster_id: 0,
    month_year: '',
    package_id: '',
    brand_submission_batches: {
      '1': { close_date: '', status: '' },
      '2': { close_date: '', status: '' },
    },
  },
  options: {
    campaignTarget: {
      isLoading: false,
      data: [],
    },
    campaignObjectives: {
      isLoading: false,

      data: [],
    },
    buyerTarget: {
      isLoading: false,
      data: [],
    },
    l0Objectives: {
      isLoading: false,
      data: [],
    },
    l1Objectives: {
      isLoading: false,
      data: [],
    },
    cluster: {
      isLoading: false,
      data: [],
    },
    packages: {
      isLoading: false,
      data: [],
    },
  },
  fileRule: { extensions: [], maxFileSize: 0, typeId: 'skp-brand-submission-attachment' },
}

const campaignUmbrellaAddEdit = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    reset: () => initialState,
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setModal: (state, action: PayloadAction<SetModalPayloadActualType>) => {
      state.modal = { ...state.modal, ...action.payload }
    },
    setOptions: (
      state,
      action: PayloadAction<Partial<CampaignUmbrellaAddEditStateType['options']>>,
    ) => {
      state.options = {
        ...state.options,
        ...action.payload,
      }
    },
    setForms: (
      state,
      action: PayloadAction<Partial<CampaignUmbrellaAddEditStateType['forms']>>,
    ) => {
      state.forms = {
        ...state.forms,
        ...action.payload,
      }
    },
    setFileRule: (state, action: PayloadAction<CampaignUmbrellaAddEditStateType['fileRule']>) => {
      state.fileRule = action.payload
    },
  },
})

export const { setIsLoading, reset, setOptions, setForms, setModal, setFileRule } =
  campaignUmbrellaAddEdit.actions
export default campaignUmbrellaAddEdit.reducer
